import { Injectable } from '@angular/core';
import { DataBagService } from '../common/data-bag.service';
import { Conversation, Result, Seller } from '../reservation/reservation.model';
import { BehaviorSubject, Subject } from 'rxjs';
import { User } from '../tasks/task.model';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { SelectionModel } from '@angular/cdk/collections';

interface IResult<key> {
	next: string;
	preview: string;
	results: key[];
}

@Injectable({
	providedIn: 'root',
})
export class MessageService {
	constructor(private readonly api: DataBagService) {}
	setFilters: Subject<boolean> = new Subject();
	archiving = false;
	conversations: MatTableDataSource<Conversation> = new MatTableDataSource<Conversation>();
	paginator: MatPaginator;
	resultsLength = 0;
	isLoadingResults = true;
	cache: { [key: string]: Result<Conversation> } = {};
	activeCacheKey = '';
	setSelection: Subject<Conversation[]> = new Subject();
	previousSelection: Conversation[] = [];
	archiveAllLoading = false;
	watchAllLoading = false;
	loggedUserId: number = null;

	clearCache() {
		for (const key in this.cache) {
			delete this.cache[key];
		}
	}

	getSellers(): Promise<Seller[]> {
		return new Promise((resolve, reject) => {
			this.api.get('/organization/', (result: IResult<Seller>, error) => {
				if (result) resolve(result.results);
				else reject(JSON.stringify(error.error));
			});
		});
	}

	getLoggedUser(): Promise<User> {
		return new Promise((resolve, reject) => {
			this.api.get('/profile/', (result: User, error) => {
				if (result) resolve(result);
				else reject(JSON.stringify(error.error));
			});
		});
	}

	getUsers(fullName?: string): Promise<User[]> {
		return new Promise((resolve, reject) => {
			this.api.get(`/profile/all_users/?full_name=${fullName}`, (result: IResult<User>, error) => {
				if (result) {
					resolve(result.results.filter((user) => user.firstName.length && user.lastName.length));
				} else {
					reject(JSON.stringify(error.error));
				}
			});
		});
	}

	watchThread(threadId: string, userIds?: number[]) {
		return new Promise((resolve, reject) => {
			this.api.post(
				`/conversation/threads/${threadId}/watch/`,
				userIds ? { userIds: userIds } : null,
				(result, error) => {
					if (error) reject(JSON.stringify(error.error));
					else resolve(true);
				},
			);
		});
	}

	unwatchThread(threadId: string) {
		return new Promise((resolve, reject) => {
			this.api.delete(`/conversation/threads/${threadId}/watch/delete/`, null, (result, error) => {
				if (error) reject(JSON.stringify(error.error));
				else resolve(true);
			});
		});
	}

	patchThread(threadId: string, data: Partial<Conversation>) {
		return new Promise((resolve, reject) => {
			this.api.patch(`/conversation/threads/${threadId}/`, data, (result, error) => {
				if (error) reject(JSON.stringify(error.error));
				else resolve(true);
			});
		});
	}
}
